import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { indigo } from '@material-ui/core/colors';
import CssBaseline from '@material-ui/core/CssBaseline';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AppRouter from './routers/AppRouter';
import CookieConsent from './components/Utils/CookieConsent';
import configureStore from './store/configureStore';

const theme = createMuiTheme({
    palette: {
        primary: indigo
    },
    typography: {
        useNextVariants: true
    },
    spacing: {
        unit: '1rem',
        double: '2rem'
    }
});

const store = configureStore();

// Wrap the app with the theme provider and Redux provider
const jsx = (
    <Provider store={store}>
        <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <CookieConsent/>
            <AppRouter />
        </MuiThemeProvider>
    </Provider>
);

let hasRendered = false;
const renderApp = () => {
    if (!hasRendered) {
        ReactDOM.render(jsx, document.getElementById('app'));
        hasRendered = true;
    }
};
renderApp();
